import { useEffect } from 'react';

export const NavigationBlocker = () => {
  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      const link = target.closest('a');

      if (link) {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    // capture phase ensures we intercept before any other handlers
    document.addEventListener('click', handleClick, { capture: true });

    return () => {
      document.removeEventListener('click', handleClick, { capture: true });
    };
  }, []);

  return null;
};
